import * as i0 from "@angular/core";
export class GeneralChartModule {
}
GeneralChartModule.ɵfac = function GeneralChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GeneralChartModule)(); };
GeneralChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: GeneralChartModule });
GeneralChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
